import styled from "styled-components";

const Heading = styled.h1`
  margin-bottom: 5px;
  font-size: 25px !important;
  font-weight: 800 !important;
`;
export default Heading;
